// ThemeContext lives in its own file so React Fast Refresh can hot-reload
// ThemeProvider.tsx (Vite's react-refresh plugin requires component files to
// export components only).

import { createContext } from 'react'
import type { ThemeContextValue } from './types'

export const ThemeContext = createContext<ThemeContextValue | null>(null)
